import CryptoJS from 'crypto-js'

import config from '../config'
import { DateUtils } from '.'

const SecurityUtils = {
    /**
     * Generates a Volume Auth Signature
     * @param {String} params.uid
     * @param {String} params.bodyString
     * @param {Number} params.timestamp
     * @param {String} params.secret
     */
    sign({ uid, bodyString, timestamp, secret }) {
        const seconds = Math.floor(timestamp / 10000)
        const string = `${uid}:${seconds}|${bodyString}:[${Math.floor(timestamp)}]`
        const signature = CryptoJS.HmacSHA256(string, secret).toString()
        return signature
    },

    socketAuthObject(body) {
        const { uid, secret } = config.socket

        const timestamp = DateUtils.now()

        const signature = SecurityUtils.sign({
            uid,
            bodyString: JSON.stringify(body),
            timestamp,
            secret,
        })

        return { uid, signature, timestamp }
    },

    generateAppCredentials(body = '{}') {
        const key = config.app.appKey.key
        const secret = config.app.appKey.secret
        const timestamp = Math.floor(Date.now() / 1000)
    
        const string = `${key}|${body}:[${timestamp}]`
        const signature = CryptoJS.HmacSHA256(string, secret).toString()

        return {
            key,
            signature,
            timestamp,
        }
    }
}

export default SecurityUtils
